// extracted by css-extract-rspack-plugin
export default {"badgeContainer":"RpJxYnQ6","medium":"HIqZK1W9"};